import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import {
  createCustomParameterFormGroup,
  createCustomParameterOptionFormGroup,
} from '../../../../modules/traffic-control/offer-wizard/step-configs/third-step.config';
import { CustomParameter } from './interfaces/interfaces';

@Component({
  selector: 'gtd-custom-parameters',
  templateUrl: './custom-parameters.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomParametersComponent {
  @Input() paramsFormArray: FormArray;
  public privacyData = {
    1: $localize`:@@common.public:Public`,
    0: $localize`:@@common.private:Private`,
  };
  public editParamId: number;
  private currentBackup: CustomParameter | null = null;

  public get paramsFormGroups(): FormGroup[] {
    return this.paramsFormArray.controls as FormGroup[];
  }

  public getParamOptionsFormGroups(paramFormGroup: FormGroup): FormGroup[] {
    return (paramFormGroup.get('available_values') as FormArray).controls as FormGroup[];
  }

  public addParameter(): void {
    const newParam = createCustomParameterFormGroup();
    (newParam.get('available_values') as FormArray).controls[0].get('is_public').disable();
    this.paramsFormArray.push(newParam);
    this.editParamId = this.paramsFormArray.length - 1;
  }

  public removeParameter(index: number): void {
    if (this.editParamId === index) {
      this.currentBackup = null;
      this.editParamId = null;
    }

    this.paramsFormArray.removeAt(index);
  }

  public editParameter(index: number): void {
    this.currentBackup = this.paramsFormArray.at(index).value;
    this.editParamId = index;
  }

  public addOption(paramGroup: FormGroup): void {
    const optionsArray = paramGroup.get('available_values') as FormArray;
    optionsArray.push(createCustomParameterOptionFormGroup(paramGroup));
  }

  public removeOption(paramGroup: FormGroup, optionIndex: number): void {
    const optionsArray = paramGroup.get('available_values') as FormArray;
    optionsArray.removeAt(optionIndex);
  }

  public onSave(): void {
    this.currentBackup = null;
    this.editParamId = null;
  }

  public onCancel(paramGroup: FormGroup): void {
    if (this.currentBackup) {
      paramGroup.patchValue(this.currentBackup);
      this.editParamId = null;
    } else {
      this.removeParameter(this.editParamId);
    }
  }

  public onCheckboxChange(paramGroup: FormGroup, changedOptionIndex: number): void {
    const options = this.getParamOptionsFormGroups(paramGroup);
    const changedOption = options[changedOptionIndex];
    const currentValue = changedOption.get('default').value;

    if (!currentValue) {
      changedOption.get('default').setValue(true);
      return;
    }

    changedOption.get('is_public').setValue(1);
    options.forEach((option, index) => {
      if (index !== changedOptionIndex) {
        option.get('default').setValue(false);
      }
    });
  }
}
